import { SubmissionReview } from './submission-review.model';

type ModuleSubmissionState = 'Approved' | 'Rejected';

export class ModuleSubmissionReview extends SubmissionReview {
    SubmissionState: ModuleSubmissionState;
    ModuleCompliances: string[];
}
